<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('cancel')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="bookingForm">
        <div class="mt-5 booked-lesson-form-fields-container">
          <label for="userId">
            Select user:
            <ng-select
              [items]="allUsers"
              placeholder="User"
              [searchable]="true"
              formControlName="user"
              id="userId"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item.firstName }} {{ item.lastName }}
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                {{ item.firstName }} {{ item.lastName }}
              </ng-template>
            </ng-select>
          </label>

          <label for="userId">
            Select child:
          <ng-select
            [items]="children"
            placeholder="Child"
            [searchable]="true"
            formControlName="child"
            id="child"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item.firstname }} {{ item.lastname }} ({{item.age}} y.o.)
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item.firstname }} {{ item.lastname }} ({{item.age}} y.o.)
            </ng-template>
          </ng-select>
          </label>

          <label for="userId">
            Select subscription:
          <ng-select
            [items]="subscriptions"
            placeholder="Subscription"
            [searchable]="true"
            formControlName="subscription"
            id="subscription"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item.isOnline ? "Online" : "In person" }} | {{ item.startDate | date }} - {{ item.endDate | date }} |
              left: {{ item.lessonsCountLeft }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item.isOnline ? "Online" : "In person" }} | {{ item.startDate | date }} - {{ item.endDate | date }} |
              left: {{ item.lessonsCountLeft }}
            </ng-template>
          </ng-select>
          </label>

          <label for="date">
            Select date:
            <input
              id="date"
              class="form-control"
              ngbDatepicker
              #d="ngbDatepicker"
              formControlName="date"
              [minDate]="minDate"
              [maxDate]="maxDate"
              (click)="d.toggle()"
              placeholder="Date"
            />
          </label>

          <label for="lesson">
            Select lessons:
            <ng-select
              [items]="allLessons"
              placeholder="Lesson"
              [searchable]="true"
              formControlName="lesson"
              id="lesson"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item.name + " " + item.startTime }} (age from {{item.minAge}} to {{item.maxAge}})
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                {{ item.name + " " + item.startTime }}
              </ng-template>
            </ng-select>
          </label>

          <div class="modal-buttons text-center">
            <button type="button"
                    [disabled]="
    !bookingForm.get('user')!.value ||
    !bookingForm.get('child')!.value ||
    !bookingForm.get('subscription')!.value ||
    !bookingForm.get('date')!.value ||
    !bookingForm.get('lesson')!.value
  "
                    class="btn btn-default add-edit-button"
                    (click)="closeModal(bookingForm)">Book
            </button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
